(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sk-faq-page"]) return;
  try {
    
  (() => {
    if (!window.Shopify || !window.Shopify.designMode || window.skFaqPageEditor) return;
    window.skFaqPageEditor = true;

    document.addEventListener('shopify:block:select', (event) => {
      if (!(event.target instanceof Element)) return;
      const item = event.target.closest('.sk-faq-page__item');
      if (item) item.open = true;
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sk-faq"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (!window.Shopify || !window.Shopify.designMode || window.skFaqEditor) return;
    window.skFaqEditor = true;

    document.addEventListener('shopify:block:select', (event) => {
      if (!(event.target instanceof Element)) return;
      const item = event.target.closest('.sk-faq__item');
      if (item) item.open = true;
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sk-footer"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sk-newsletter')) {
    customElements.define(
      'sk-newsletter',
      class SkNewsletter extends HTMLElement {
        connectedCallback() {
          if (this.controller) return;
          this.form = this.querySelector('form');
          this.input = this.querySelector('input[type="email"]');
          this.status = this.querySelector('[data-sk-newsletter-status]');
          if (!this.form || !this.input || !this.status) return;

          this.controller = new AbortController();
          const { signal } = this.controller;
          this.form.noValidate = true;
          // Capture phase, so an invalid address is stopped before Shopify's spam-protection (hCaptcha) submit
          // handlers run: they ignore defaultPrevented, open a captcha and then submit the form natively.
          this.form.addEventListener('submit', (event) => this.onSubmit(event), { capture: true, signal });
          this.input.addEventListener('input', () => this.onInput(), { signal });

          const notice = this.status.querySelector('.sk-footer__message');
          if (notice) this.focusNotice(notice, signal);
        }

        focusNotice(notice, signal) {
          let interacted = false;
          const mark = () => {
            interacted = true;
          };
          document.addEventListener('pointerdown', mark, { capture: true, once: true, signal });
          document.addEventListener('keydown', mark, { capture: true, once: true, signal });
          notice.addEventListener(
            'blur',
            (event) => {
              if (!interacted && !event.relatedTarget) requestAnimationFrame(() => notice.focus());
            },
            { once: true, signal }
          );
          if (!document.activeElement || document.activeElement === document.body) notice.focus();
        }

        disconnectedCallback() {
          if (this.controller) this.controller.abort();
          this.controller = null;
          clearTimeout(this.timer);
        }

        isValid() {
          const value = this.input.value.trim();
          return this.input.validity.valid && /^[^\s@]+@[^\s@]+\.[^\s@.]{2,}$/.test(value);
        }

        onSubmit(event) {
          if (this.isValid()) return;
          event.preventDefault();
          event.stopImmediatePropagation();
          this.showError();
        }

        onInput() {
          if (this.input.getAttribute('aria-invalid') === 'true' && this.isValid()) this.clearError();
        }

        describe(ids) {
          const value = ids.filter(Boolean).join(' ');
          if (value) {
            this.input.setAttribute('aria-describedby', value);
          } else {
            this.input.removeAttribute('aria-describedby');
          }
        }

        showError() {
          const { errorId, consentId, invalidText } = this.dataset;
          this.input.setAttribute('aria-invalid', 'true');
          this.describe([errorId, consentId]);
          this.status.replaceChildren();
          clearTimeout(this.timer);
          this.timer = setTimeout(() => {
            const message = document.createElement('p');
            message.className = 'sk-footer__message sk-footer__message--error';
            message.id = errorId;
            message.textContent = invalidText;
            this.status.replaceChildren(message);
          }, 100);
          if (document.activeElement !== this.input) this.input.focus();
        }

        clearError() {
          clearTimeout(this.timer);
          this.input.removeAttribute('aria-invalid');
          this.describe([this.dataset.consentId]);
          this.status.querySelectorAll('.sk-footer__message--error').forEach((node) => node.remove());
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sk-hair-types"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sk-hair-types')) {
    customElements.define(
      'sk-hair-types',
      class extends HTMLElement {
        connectedCallback() {
          if (this.controller) return;
          this.tablist = this.querySelector('[role="tablist"]');
          if (!this.tablist) return;
          this.tabs = Array.from(this.tablist.querySelectorAll('[role="tab"]'));
          this.panels = this.tabs.map((tab) =>
            this.querySelector(`#${CSS.escape(tab.getAttribute('aria-controls') || '')}`)
          );
          if (!this.tabs.length || this.panels.includes(null)) return;

          this.controller = new AbortController();
          const { signal } = this.controller;

          this.tabs.forEach((tab, index) => {
            const panel = this.panels[index];
            panel.setAttribute('role', 'tabpanel');
            panel.setAttribute('aria-labelledby', tab.id);
            panel.tabIndex = 0;
          });
          const selected = this.tabs.findIndex((tab) => tab.getAttribute('aria-selected') === 'true');
          this.select(Math.max(selected, 0));

          this.tablist.addEventListener(
            'click',
            (event) => {
              const index = this.tabs.indexOf(event.target.closest('[role="tab"]'));
              if (index > -1) this.select(index, { reveal: true });
            },
            { signal }
          );
          this.tablist.addEventListener('keydown', (event) => this.onKeydown(event), { signal });

          const warm = () => {
            this.querySelectorAll('img[loading="lazy"]').forEach((image) => {
              image.loading = 'eager';
            });
          };
          this.tablist.addEventListener('pointerover', warm, { signal, once: true });
          this.tablist.addEventListener('focusin', warm, { signal, once: true });

          this.addEventListener(
            'shopify:block:select',
            (event) => {
              const index = this.panels.findIndex((panel) => panel.contains(event.target));
              if (index > -1) this.select(index, { reveal: true });
            },
            { signal }
          );
        }

        disconnectedCallback() {
          this.controller?.abort();
          this.controller = null;
        }

        onKeydown(event) {
          const current = this.tabs.indexOf(event.target.closest('[role="tab"]'));
          if (current < 0 || event.altKey || event.ctrlKey || event.metaKey) return;
          const last = this.tabs.length - 1;
          const rtl = getComputedStyle(this.tablist).direction === 'rtl';
          const next = rtl ? 'ArrowLeft' : 'ArrowRight';
          const previous = rtl ? 'ArrowRight' : 'ArrowLeft';
          let index;
          if (event.key === next) index = current === last ? 0 : current + 1;
          else if (event.key === previous) index = current === 0 ? last : current - 1;
          else if (event.key === 'Home') index = 0;
          else if (event.key === 'End') index = last;
          else return;
          event.preventDefault();
          this.select(index, { focus: true, reveal: true });
        }

        select(index, { focus = false, reveal = false } = {}) {
          this.tabs.forEach((tab, i) => {
            const active = i === index;
            tab.setAttribute('aria-selected', String(active));
            tab.tabIndex = active ? 0 : -1;
            this.panels[i].hidden = !active;
          });
          const tab = this.tabs[index];
          if (focus) tab.focus({ preventScroll: true });
          if (reveal) this.reveal(tab);
        }

        reveal(tab) {
          const list = this.tablist;
          if (list.scrollWidth <= list.clientWidth) return;
          const inset = parseFloat(getComputedStyle(list).paddingLeft) || 0;
          const listBox = list.getBoundingClientRect();
          const tabBox = tab.getBoundingClientRect();
          let delta = 0;
          if (tabBox.left < listBox.left + inset) delta = tabBox.left - listBox.left - inset;
          else if (tabBox.right > listBox.right - inset) delta = tabBox.right - listBox.right + inset;
          if (!delta) return;
          const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          list.scrollBy({ left: delta, behavior: reduced ? 'auto' : 'smooth' });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sk-video"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sk-video-player')) {
    customElements.define(
      'sk-video-player',
      class extends HTMLElement {
        connectedCallback() {
          if (this.controller) return;
          this.video = this.querySelector('video');
          this.toggle = this.querySelector('.sk-video__toggle');
          if (!this.video || !this.toggle || !this.hasAttribute('data-autoplay')) return;

          this.controller = new AbortController();
          const { signal } = this.controller;
          this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
          this.onScreen = false;
          this.userPaused = false;
          this.observer = new IntersectionObserver(
            (entries) => {
              const entry = entries[entries.length - 1];
              this.onScreen = entry.isIntersecting && entry.intersectionRatio >= 0.25;
              this.update();
            },
            { threshold: [0, 0.25, 0.5] }
          );

          this.toggle.addEventListener(
            'click',
            () => {
              this.userPaused = !this.userPaused;
              this.update();
            },
            { signal }
          );
          this.motion.addEventListener('change', () => this.setMode(), { signal });
          this.setMode();
        }

        disconnectedCallback() {
          if (this.controller) this.controller.abort();
          if (this.observer) this.observer.disconnect();
          this.controller = null;
          this.observer = null;
        }

        setMode() {
          this.auto = !this.motion.matches;
          if (this.auto) {
            this.video.muted = true;
            this.video.loop = true;
            this.video.removeAttribute('controls');
            this.toggle.hidden = false;
            this.observer.observe(this);
          } else {
            this.observer.disconnect();
            this.onScreen = false;
            this.video.pause();
            this.video.loop = false;
            this.video.setAttribute('controls', '');
            this.toggle.hidden = true;
          }
          this.update();
        }

        update() {
          const play = this.auto && this.onScreen && !this.userPaused;
          if (play && this.video.paused) {
            const attempt = this.video.play();
            if (attempt) {
              attempt.catch((error) => {
                if (!error || error.name !== 'NotAllowedError' || !this.video.paused) return;
                this.userPaused = true;
                this.toggle.setAttribute('aria-pressed', 'true');
              });
            }
          } else if (!play && !this.video.paused) {
            this.video.pause();
          }
          this.toggle.setAttribute('aria-pressed', String(this.userPaused));
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
